export default "__VITE_ASSET__D2wyPhK4__"